import React, { Component } from "react"
import { TM } from "../../common/typography/trademark"
import * as styles from "./declineBountyContest.module.scss"

class declineBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  en() {
    return (
      <div className={styles.carouselGraphic3}>
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <h2>
              Decline to register for the IronCAP
              <TM /> Bounty Contest{" "}
            </h2>
            <p>
              Declining to register means you won't have an account to login to
              obtain the public key and the ciphertext. In other words, you have
              no privilege to participate in the contest even you manage to
              decipher the puzzle.
            </p>

            <p>
              <b>Why registration is required</b>
              <br />
              Our commitment to a fair contest is to help everyone better
              understand what to expect from us, and what we expect from them so
              as to ensure the contest is held as fair as possible.
            </p>

            <p>
              <b>If you want to register again</b>
              <br />
              If you change your mind, you are welcome to try the registration
              process again by accepting our rules and conditions. However,
              please note that our contest closing date has been fixed and will
              not be extended.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="offset-md-2 col-md-2 btn-group">
            <button
              className="btn btn-agreement-accept"
              onClick={this.props.handleReturnToAgreement}
            >
              Go back{" "}
            </button>
          </div>

          <div className="col-md-2 btn-group">
            <button
              className="btn btn-agreement-cancel"
              onClick={this.props.handleReturnToWelcome}
            >
              Cancel signup{" "}
            </button>
          </div>
        </div>
      </div>
    )
  }

  // ct
  ct() {
    return (
      <div className={styles.carouselGraphic3}>
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <h2>
              拒絕註冊 IronCAP
              <TM /> 賞金比賽{" "}
            </h2>
            <p>
              拒絕註冊意指您將無法獲得可以登錄賞金比賽的賬戶，且無法獲得公鑰和密文。換句話說，即使您可以解開密碼，也無權參加比賽。
            </p>

            <p>
              <b>為什麼需要註冊</b>
              <br />
              我們對公平比賽的承諾是令各位更好地理解我們的期望以及我們對各位的期望，以確保比賽盡可能公平地舉行。
            </p>

            <p>
              <b>如果您想再次註冊</b>
              <br />
              如果您改變主意，歡迎您接受我們的規則和條件，重新嘗試註冊。
              但是，請注意，我們的比賽結束日期是固定的，不會延長。
            </p>
          </div>
        </div>

        <div className="row">
          <div className="offset-md-2 col-md-2 btn-group">
            <button
              className="btn btn-agreement-accept"
              onClick={this.props.handleReturnToAgreement}
            >
              返回{" "}
            </button>
          </div>

          <div className="col-md-2 btn-group">
            <button
              className="btn btn-agreement-cancel"
              onClick={this.props.handleReturnToWelcome}
            >
              取消註冊{" "}
            </button>
          </div>
        </div>
      </div>
    )
  }

  // ct end
}

export default declineBountyContest
